import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    min-height: 100dvh;
    background-color: var(--sds-color-background-default-default);
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
  }

  .logo {
    width: 40px;
    height: 40px;
  }

  .title {
    color: var(--sds-color-text-default-default);
    /* Title Page */
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-title-page-size);
    font-style: normal;
    font-weight: var(--sds-typography-weight-medium);
    line-height: 120%;
    margin: 0;
  }

  .description {
    color: var(--sds-color-text-default-default);

    /* Body Large */
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-large);
    font-style: normal;
    font-weight: var(--sds-typography-weight-regular);
    line-height: 140%; /* 22.4px */
    opacity: 0.6;
    margin: 0;
    margin-bottom: var(--sds-size-space-300);
  }

  .scrollable-step {
    overflow-y: auto;
    height: 100dvh;
  }

  /* Email verification step styles */
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100dvh;
    width: 100%;
    background-color: var(--sds-color-background-neutral-subtle);
    color: var(--sds-color-text-default-inverse);
    box-sizing: border-box;
  }

  .content {
    width: 100%;
    max-width: 393px;
    background-color: var(--sds-color-background-neutral-strong);
    border-radius: var(--sds-size-border-radius-200);
    margin: 0 auto;
    padding: var(--sds-size-space-800);
    display: flex;
    flex-direction: column;
    flex: 1;
    box-sizing: border-box;
  }

  .scrollable-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    overflow-y: auto;
    min-height: 0;
  }

  .sticky-button-container {
    padding-top: var(--sds-size-space-600);
    border-top: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-neutral-strong);
  }

  .verification-body {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .verification-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
    color: var(--sds-color-text-default-inverse);
  }

  .verification-text {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-02);
    line-height: 1.5;
    color: var(--sds-color-text-default-secondary);
    margin: 0;
    white-space: pre-line;
    overflow-wrap: break-word;
  }

  /* Onboarding step styles */
  .onboarding-scroll-container {
    overflow-y: auto;
    width: 100%;
    max-width: 393px;
    margin: 0 auto;
    padding: 0 var(--sds-size-space-400);
    box-sizing: border-box;
  }

  .onboarding-main-content {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
    width: 100%;
    box-sizing: border-box;
  }

  .onboarding-header {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-800);
  }

  .onboarding-title-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
  }

  .onboarding-title {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
  }

  .onboarding-subtitle {
    font-family: var(--sds-typography-family-body);
    font-weight: var(--sds-typography-weight-regular);
    font-size: var(--sds-typography-scale-03);
    line-height: 1.4;
    color: var(--sds-color-text-default-secondary);
  }

  .onboarding-form-section {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .onboarding-sticky-button-container {
    position: sticky;
    bottom: 0;
    background: var(--sds-color-background-default-default);
    padding: var(--sds-size-space-800) 0;
    border-top: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
  }

  .onboarding-submit-button {
    display: grid;
    width: 100%;
  }

  .social-links-content {
    display: grid;
    gap: var(--sds-size-space-300);
    overflow-y: auto;
  }

  .italic {
    font-style: italic;
  }

  .logo {
    margin-bottom: var(--sds-size-space-1600);
  }

  @media (min-width: 768px) {
    .container {
      padding: var(--sds-size-space-800);
      padding-bottom: 0;
    }

    .onboarding-scroll-container {
      padding: 0 var(--sds-size-space-800);
    }

    .verification-title {
      font: var(--sds-typography-weight-medium) var(--sds-typography-scale-06) / 1.2 var(--sds-typography-family-title);
    }

    .verification-text {
      font-size: var(--sds-typography-scale-03);
    }

    .social-links-content {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 1200px) {
    .onboarding-sticky-button-container {
      position: inherit;
      border-top: none;
      padding-top: 0;
    }

    .onboarding-submit-button {
      margin-top: var(--sds-size-space-800);
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-400);
    width: 100%;
  }

  wow-sticky-button-container {
    margin: 0 calc(-1 * var(--sds-size-space-800));
  }

  wow-sticky-button-container wow-button {
    flex: 1;
    min-width: 0;
  }

  .spinner {
    display: inline-block;
    width: var(--sds-size-space-600);
    height: var(--sds-size-space-600);
    vertical-align: middle;
    transform-origin: 50% 50%;
    animation: ph-spin 1s linear infinite;
    pointer-events: none;
  }

  @keyframes ph-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
